import $ from 'jquery';
import ApexCharts from 'apexcharts';

$(function () {
    const $container = $('#emergency-calculator-app');
    if (!$container.length) return;

    let currency = $container.data('currency') || 'UAH';
    let symbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : currency === 'PLN' ? 'zł' : '₴';
    let chartInstance = null;

    const textMoreCurrencies = $container.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $container.data('text-more-short') || 'Ще';

    const $initBtn = $('#emergency-currency-tabs button.active');
    if ($initBtn.length) {
        currency = $initBtn.data('currency-code') || currency;
        symbol = $initBtn.data('symbol') || symbol;
    }

    const unitMonths = $container.data('unit-months') || 'міс.';
    const unitPerMonth = $container.data('unit-per-month') || '/ міс';
    const tier1Label = $container.data('tier1-label') || 'Рівень 1: Готівка/Картка (20%)';
    const tier2Label = $container.data('tier2-label') || 'Рівень 2: Гнучкі депозити (40%)';
    const tier3Label = $container.data('tier3-label') || 'Рівень 3: Короткі ОВДП (40%)';

    const $monthsRange = $('#em-months-range');
    const $monthsDisplay = $('#em-months-display');

    const $housingRange = $('#em-housing-range');
    const $housingDisplay = $('#em-housing-display');

    const $foodRange = $('#em-food-range');
    const $foodDisplay = $('#em-food-display');

    const $healthRange = $('#em-health-range');
    const $healthDisplay = $('#em-health-display');

    const $obligationsRange = $('#em-obligations-range');
    const $obligationsDisplay = $('#em-obligations-display');

    const $otherRange = $('#em-other-range');
    const $otherDisplay = $('#em-other-display');

    function formatMoney(num) {
        return Math.round(num).toLocaleString('uk-UA') + ' ' + symbol;
    }

    function calculate() {
        const months = parseInt($monthsRange.val(), 10) || 6;
        const housing = parseFloat($housingRange.val()) || 0;
        const food = parseFloat($foodRange.val()) || 0;
        const health = parseFloat($healthRange.val()) || 0;
        const obligations = parseFloat($obligationsRange.val()) || 0;
        const other = parseFloat($otherRange.val()) || 0;

        $monthsDisplay.text(months + ' ' + unitMonths);
        $housingDisplay.text(formatMoney(housing));
        $foodDisplay.text(formatMoney(food));
        $healthDisplay.text(formatMoney(health));
        $obligationsDisplay.text(formatMoney(obligations));
        $otherDisplay.text(formatMoney(other));

        const monthlyTotal = housing + food + health + obligations + other;
        const targetTotal = Math.round(monthlyTotal * months);

        const tier1 = Math.round(targetTotal * 0.20);
        const tier2 = Math.round(targetTotal * 0.40);
        const tier3 = Math.round(targetTotal * 0.40);

        $('#em-kpi-total').text(formatMoney(targetTotal));
        $('#em-kpi-monthly').text(formatMoney(monthlyTotal) + ' ' + unitPerMonth);
        $('#em-kpi-months').text(months + ' ' + unitMonths);

        $('#em-tier1-val').text(formatMoney(tier1));
        $('#em-tier2-val').text(formatMoney(tier2));
        $('#em-tier3-val').text(formatMoney(tier3));

        renderChart(tier1, tier2, tier3);
    }

    function renderChart(t1, t2, t3) {
        const isDark = $('body').hasClass('dark') || $('body').attr('data-layout-mode') === 'dark';

        const options = {
            series: [t1, t2, t3],
            labels: [tier1Label, tier2Label, tier3Label],
            chart: {
                type: 'donut',
                height: 240,
                animations: { enabled: true, speed: 400 }
            },
            colors: ['#50a5f1', '#556ee6', '#34c38f'],
            legend: {
                position: 'bottom',
                labels: { colors: isDark ? '#a6b0cf' : '#74788d' }
            },
            stroke: {
                colors: [isDark ? '#2a3042' : '#ffffff'],
                width: 2
            },
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    return Math.round(val) + '%';
                }
            },
            tooltip: {
                theme: isDark ? 'dark' : 'light',
                y: {
                    formatter: function (val) {
                        return formatMoney(val);
                    }
                }
            }
        };

        const chartEl = document.querySelector('#emergency-tiers-chart');
        if (!chartEl) return;

        if (chartInstance) {
            chartInstance.updateOptions(options);
        } else {
            chartInstance = new ApexCharts(chartEl, options);
            chartInstance.render();
        }
    }

    // Sliders input
    $monthsRange.on('input', calculate);
    $housingRange.on('input', calculate);
    $foodRange.on('input', calculate);
    $healthRange.on('input', calculate);
    $obligationsRange.on('input', calculate);
    $otherRange.on('input', calculate);

    // Profile presets
    $('.profile-btn').on('click', function () {
        $('.profile-btn').removeClass('active');
        $(this).addClass('active');
        const m = parseInt($(this).data('months'), 10) || 6;
        $monthsRange.val(m);
        calculate();
    });

    // Currency Switcher
    function setEmergencyCurrency(btn, isDropdown) {
        currency = $(btn).data('currency-code');
        symbol = $(btn).data('symbol') || '$';

        if (isDropdown) {
            $('#emergency-currency-tabs > button[data-currency-code]').removeClass('active');
            $('.emergency-currency-dropdown-item').removeClass('active');
            $(btn).addClass('active');
            $('.emergency-more-currencies-btn').addClass('active');
            $('#emergency-active-custom-currency').text(`${symbol} ${currency}`);
        } else {
            $('#emergency-currency-tabs button').removeClass('active');
            $(btn).addClass('active');
            $('.emergency-more-currencies-btn').removeClass('active');
            $('.emergency-currency-dropdown-item').removeClass('active');
            $('#emergency-active-custom-currency').html(`
                <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
                <span class="d-sm-none">${textMoreShort}</span>
            `);
        }

        const housing = parseFloat($(btn).data('housing')) || 12000;
        const food = parseFloat($(btn).data('food')) || 8000;
        const health = parseFloat($(btn).data('health')) || 3000;
        const obligations = parseFloat($(btn).data('obligations')) || 4000;
        const other = parseFloat($(btn).data('other')) || 3000;

        $housingRange.val(housing);
        $foodRange.val(food);
        $healthRange.val(health);
        $obligationsRange.val(obligations);
        $otherRange.val(other);

        if (currency === 'USD' || currency === 'EUR' || currency === 'GBP' || currency === 'CHF' || currency === 'CAD') {
            $housingRange.attr({ max: 5000, step: 50 });
            $foodRange.attr({ max: 3000, step: 25 });
            $healthRange.attr({ max: 2000, step: 25 });
            $obligationsRange.attr({ max: 3000, step: 50 });
            $otherRange.attr({ max: 2000, step: 25 });
        } else if (currency === 'PLN') {
            $housingRange.attr({ max: 15000, step: 100 });
            $foodRange.attr({ max: 10000, step: 100 });
            $healthRange.attr({ max: 5000, step: 50 });
            $obligationsRange.attr({ max: 10000, step: 100 });
            $otherRange.attr({ max: 6000, step: 50 });
        } else {
            $housingRange.attr({ max: 60000, step: 500 });
            $foodRange.attr({ max: 40000, step: 500 });
            $healthRange.attr({ max: 25000, step: 250 });
            $obligationsRange.attr({ max: 40000, step: 500 });
            $otherRange.attr({ max: 30000, step: 250 });
        }

        calculate();
    }

    $('#emergency-currency-tabs > button[data-currency-code]').on('click', function () {
        setEmergencyCurrency(this, false);
    });

    $(document).on('click', '.emergency-currency-dropdown-item', function (e) {
        e.preventDefault();
        setEmergencyCurrency(this, true);
    });

    calculate();
});

